/**
 * @desc 库存汇总分页查询
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.stockPool.page.Params, options?: any) {
  return updateResponse(
    http(URL + `/stockPool/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
